export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Files.json?hash=9e79e0301ce9512e9357bf658af00959";